import { useEffect, useState } from 'react';
import WapOnly from '../Responsive/WapOnly';
import WebOnly from '../Responsive/WebOnly';
import PrescriptionTableM from './components/m';
import PrescriptionTablePC from './components/pc';
export default function PrescriptionTable({
  prescription,
  isReadOnly = false,
  showImage = false,
  showHeaderInfo = false,
  onDelete,
  onEdit,
  onUploadImg,
  showPrism = false,
  showGray,
  showError,
}: {
  prescription: any;
  // 是否只读. 只读时不展示上传图片、按钮、处方名称
  isReadOnly?: boolean;
  // 是否展示底部的图片信息（仅isReadOnly为true有效果，且不可上传）
  showImage?: boolean;
  // 是否展示头部的处方名称、处方类型、最近更新日期（仅isReadOnly为true有效果）
  showHeaderInfo?: boolean;
  // 是否展示棱镜, 默认不展示, 如果为true, 则展示棱镜
  showPrism?: boolean;
  onDelete: () => void;
  onEdit: () => void;
  onUploadImg: (path: string) => void;
  showGray?: boolean;
  showError?: boolean;
}) {
  const [currentPrescription, setCurrentPrescription] = useState(prescription);

  useEffect(() => {
    const _prescription = { ...prescription };
    ['od_sph', 'os_sph', 'od_cyl', 'os_cyl', 'od_add', 'os_add'].forEach((item) => {
      const value = prescription.prescription[item];

      // 如果是空值（null、undefined、空字符串、或只有空格），显示中划线
      if (!value || value.toString().trim() === '') {
        _prescription.prescription[item] = '-';
        return;
      }

      const reg = /[^0-9.]/g;
      if (!reg.test(value) && value !== '0.00') {
        _prescription.prescription[item] = `+${value}`;
      }
    });
    setCurrentPrescription(_prescription);
  }, [prescription]);

  return (
    <div>
      <WapOnly>
        <PrescriptionTableM
          prescription={currentPrescription}
          isReadOnly={isReadOnly}
          showImage={showImage}
          showHeaderInfo={showHeaderInfo}
          onDelete={onDelete}
          onEdit={onEdit}
          onUploadImg={onUploadImg}
          showGray={showGray}
          showError={showError}
        />
      </WapOnly>
      <WebOnly>
        <PrescriptionTablePC
          prescription={currentPrescription}
          isReadOnly={isReadOnly}
          showImage={showImage}
          showHeaderInfo={showHeaderInfo}
          onDelete={onDelete}
          onEdit={onEdit}
          onUploadImg={onUploadImg}
          showPrism={showPrism}
          showGray={showGray}
          showError={showError}
        />
      </WebOnly>
    </div>
  );
}
